import { render } from "./Info.vue?vue&type=template&id=653247fb&scoped=true"
import script from "./Info.vue?vue&type=script&lang=js"
export * from "./Info.vue?vue&type=script&lang=js"

import "./Info.vue?vue&type=style&index=0&id=653247fb&lang=css&scoped=true"

import exportComponent from "/Users/soup/Development/Vue/futurefest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-653247fb"]])

export default __exports__